import api from "@/services/api";
import blob from "@/services/blob";

export default {
  get_diet_plan(payload) {
    return api.get(
      "diets/" 
      + payload.id + "/"
      , payload).then(response => response.data);
  },
  save_diet_plan(payload) {
    return api.put(
      "diets/" 
      + payload.id + "/"
      , payload.form).then(response => response.data);
  },
  create_diet_plan(payload) {
    return api.post("diets/", payload)
      .then(response => response.data);
  },
  delete_diet_plan(payload) {
    return api.delete(
      "diets/" 
      + payload.id + "/"
    ).then(response => response.data);
  },
  clone_diet(payload) {
    return api.post(
      "diets/" + payload.id + "/clone/"
      , payload)
      .then(response => response.data);
  },
  get_portions_suggestion(payload) {
    return api.post(
      "diets/" + payload.id + "/portion_suggestion/"
      , payload ).then(response => response.data);
  },
  get_food_details(payload) {
    return api.post(
      "diets/" + payload.dietId + "/food_details/"
      , payload ).then(response => response.data);
  },
  download_diet_plan(payload) {
    return blob.post(
      "diets/" + payload.id + "/download/"
      , payload.form ).then(response => response.data);
  }
};